import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {
  private isPropertiesEmpty: boolean = false;

  constructor() {}

  setPropertiesStatus(status: boolean) {
    this.isPropertiesEmpty = status;
  }

  getPropertiesStatus(): boolean {
    return this.isPropertiesEmpty;
  }
}
